/* eslint-disable jira/i18n/id-named-by-package */
import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'eoc-changeboarding.wizard.steps.one.title-no-translate',
		defaultMessage: 'Shift your work from Opsgenie to Jira',
		description: 'Title of step one',
	},
	description: {
		id: 'eoc-changeboarding.wizard.steps.one.description-no-translate',
		defaultMessage:
			'Make Jira Service Management your team’s central place to do all the operations work that they currently do with Opsgenie.',
		description: 'Description of step one',
	},
	alertsTitle: {
		id: 'eoc-changeboarding.wizard.steps.one.alerts-title-no-translate',
		defaultMessage: 'Respond to alerts',
		description: 'Title of alerts section',
	},
	alertsDescription: {
		id: 'eoc-changeboarding.wizard.steps.one.alerts-description-no-translate',
		defaultMessage: 'Work on your alerts natively from Jira Service Management’s Your work page.',
		description: 'Description of alerts section',
	},
	operationsTitle: {
		id: 'eoc-changeboarding.wizard.steps.one.operations-title-no-translate',
		defaultMessage: 'Manage operations',
		description: 'Title of operations section',
	},
	operationsDescription: {
		id: 'eoc-changeboarding.wizard.steps.one.operations-description-no-translate',
		defaultMessage:
			'Find your integrations, custom roles, maintenance, notifications, policies, audit logs, and more in Jira settings.',
		description: 'Description of alerts section',
	},
	mobileTitle: {
		id: 'eoc-changeboarding.wizard.steps.one.mobile-title-no-translate',
		defaultMessage: 'Get mobile notifications',
		description: 'Title of mobile section',
	},
	mobileDescription: {
		id: 'eoc-changeboarding.wizard.steps.one.mobile-description-no-translate',
		defaultMessage:
			'Stay notified of alerts, check on-call schedules, and manage notification rules on the go with Jira Cloud mobile.',
		description: 'Description of mobile notifications section',
	},
});
